export const LOAD_CONTENT = 'mp/confirmation/LOAD_CONTENT';
export const DL_PAGE_LOADED = 'mp/confirmation/DL_PAGE_LOADED';
export const SET_DATA = 'mp/confirmation/SET_DATA';

export const loadContent = () => {
  return {
    type: LOAD_CONTENT
  };
};



/** WEBPACK FOOTER **
 ** ./client/redux/modules/pages/MyPlan/confirmation/confirmation.js
 **/